import { getTreeNodeChildren, type TreeNode } from './treeNode'

export const isLastParentNode = (
  node: TreeNode | null | undefined
): boolean => {
  if (!node) return false

  const children = getTreeNodeChildren(node)

  if (children.length === 0) return true

  return children.every((child) => getTreeNodeChildren(child).length === 0)
}
